/**
 * @generated SignedSource<<b1c2aac918d74606fe2bcc9abd8a40e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavHeader_viewer$data = {
  readonly seller?: {
    readonly " $fragmentSpreads": FragmentRefs<"NavHelp_seller">;
  } | null;
  readonly " $fragmentType": "NavHeader_viewer";
};
export type NavHeader_viewer$key = {
  readonly " $data"?: NavHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasSellerPk"
    },
    {
      "kind": "RootArgument",
      "name": "sellerPk"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavHeader_viewer",
  "selections": [
    {
      "condition": "hasSellerPk",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "sellerId",
              "variableName": "sellerPk"
            }
          ],
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavHelp_seller"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "451d42a9cd502f251c2248323b53509c";

export default node;
